export function uniqueId(prefix = 'id'): string {
    if (typeof crypto?.randomUUID === 'function') {
        return `${prefix}-${crypto.randomUUID()}`;
    }
    return `${prefix}-${Math.random().toString(36).slice(2)}`;
}